import { Box, CircularProgress, Container, Grid, Paper } from '@mui/material'
import Switch from '@mui/material/Switch'
import { DataGridPremium } from '@mui/x-data-grid-premium'
import { keyframes, styled } from '@mui/material/styles'

export const MaterialUISwitch = styled(Switch)(({ theme }: any) => ({
	width: 62,
	height: 34,
	padding: 7,
	'& .MuiSwitch-switchBase': {
		margin: 1,
		padding: 0,
		transform: 'translateX(6px)',
		'&.Mui-checked': {
			color: '#fff',
			transform: 'translateX(22px)',
			'& .MuiSwitch-thumb:before': {
				backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
					'#fff',
				)}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
			},
			'& + .MuiSwitch-track': {
				opacity: 1,
				backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
			},
		},
	},
	'& .MuiSwitch-thumb': {
		backgroundColor: theme.palette.mode === 'dark' ? '#003892' : '#001e3c',
		width: 32,
		height: 32,
		'&:before': {
			content: "''",
			position: 'absolute',
			width: '100%',
			height: '100%',
			left: 0,
			top: 0,
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
				'#fff',
			)}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
		},
	},
	'& .MuiSwitch-track': {
		opacity: 1,
		backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
		borderRadius: 20 / 2,
	},
}))

export const DrawerHeader = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end',
	padding: theme.spacing(0, 1),
	// necessary for content to be below app bar
	...theme.mixins.toolbar,
	minHeight: '64px',
	height: '64px',
	'@media (min-width: 600px)': {
		minHeight: '64px',
	},
}))

export const ContentContainer = styled('div')(({ theme }) => ({
	padding: '1rem',
	borderBottomLeftRadius: '0.5rem',
	borderBottomRightRadius: '0.5rem',
	backgroundColor:
		theme.palette.mode === 'dark' ? 'rgba(50,48,54, 0.65)' : '#fff',
	borderBottom: `1px solid ${theme.palette.divider}`,
}))

export const StyledDataGrid = styled(DataGridPremium)(({ theme }) => ({
	color:
		theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.85)',
	WebkitFontSmoothing: 'auto',
	letterSpacing: 'normal',
	// backgroundColor: theme.palette.mode === 'dark' ? '#333' : '#fff',
	// '& .MuiDataGrid-columnHeader': {
	// 	backgroundColor: theme.palette.mode === 'dark' ? '#444' : '#d2dae2',
	// 	fontWeight: 600,
	// },
	// '& .MuiDataGrid-columnHeaders .MuiDataGrid-filler': {
	// 	backgroundColor: theme.palette.mode === 'dark' ? '#444' : '#d2dae2',
	// 	fontWeight: 600,
	// },
	// '& .MuiDataGrid-columnHeaders.MuiDataGrid-filler': {
	// 	backgroundColor: theme.palette.mode === 'dark' ? '#333' : '#fff',
	// },
	// '& .MuiDataGrid-columnsContainer': {
	// 	backgroundColor: theme.palette.mode === 'light' ? '#fafafa' : '#1d1d1d',
	// },
	// '& .MuiDataGrid-iconSeparator': {
	// 	display: 'none',
	// },
	// '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
	// 	borderRight: `1px solid ${
	// 		theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'
	// 	}`,
	// },
	// '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
	// 	borderBottom: `1px solid ${
	// 		theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'
	// 	}`,
	// },
	// '& .MuiDataGrid-cell': {
	// 	color:
	// 		theme.palette.mode === 'light'
	// 			? 'rgba(0,0,0,.85)'
	// 			: 'rgba(255,255,255,0.65)',
	// },
	// '& .MuiPaginationItem-root': {
	// 	borderRadius: 0,
	// },
}))

// 게시물 열람시 에디터 스타일
export const BoardViewBg = styled('div')(({ theme }) => ({
	backgroundColor:
		theme.palette.mode === 'dark' ? 'rgba(50,48,54, 0.65)' : '#fff',
	border: '1px solid #e0e0e0',
	padding: '1rem',
	minHeight: '300px',
	height: 'auto',
}))

// 게시물 열람시 상단 정보
export const BoardViewHeader = styled(Grid)(({ theme }) => ({
	marginBottom: '2rem',
	'.title': {
		borderBottom: '1px solid #ccc',
		paddingBottom: '1rem',
		display: 'block',
		width: '100%',
	},
}))

// 로딩 스타일
export const LoaderContainer = styled(`div`)(({ theme }) => ({
	position: 'absolute',
	top: 0,
	right: 0,
	bottom: 0,
	left: 0,
	backgroundColor: 'rgba(0, 0, 0, 0.5)',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
}))
export const LoaderIcon = styled(CircularProgress)(({ theme }) => ({
	color: theme.palette.primary.main,
}))

// 검색 UI
export const SearchContainer = styled('form')(({ theme }) => ({
	padding: '1rem',
	borderBottomLeftRadius: '0.5rem',
	borderBottomRightRadius: '0.5rem',
	backgroundColor:
		theme.palette.mode === 'dark' ? 'rgba(50,48,54, 0.65)' : '#fff',
	borderBottom: `1px solid ${theme.palette.divider}`,
}))

// 각 페이지의 그리드 화면 분배
export const PageContainer = styled(Grid)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
	height: '100%',
}))

export const PageTop = styled('div')(({ theme }) => ({
	marginBottom: '15px',
}))

export const GridContainer = styled(Grid)(({ theme }) => ({
	flexGrow: 1,
	padding: '1rem',
	height: '100%',
	backgroundColor:
		theme.palette.mode === 'dark' ? 'rgba(50,48,54, 0.65)' : '#fff',
	borderBottom: `1px solid ${theme.palette.divider}`,
	borderRadius: '0.5rem',
}))
// 각 페이지의 그리드 스타일
export const StyledDataGridContainer = styled('div')(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#333' : '#fff',
	borderRadius: '0.5rem',
	boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
	padding: '0.8rem',
	height: 'calc(100vh - 274px)',
}))
// 그리드 없이 사용하는 페이지 스타일
export const StyledPageContainer = styled('div')(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#333' : '#fff',
	borderRadius: '0.5rem',
	boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
	padding: '0.8rem',
	height: 'calc(100vh - 155px)',
}))
export const StyleContentContainer = styled('div')(({ theme }) => ({
	position: 'relative',
	marign: 0,
}))

export const StyledSearchForm = styled('div')(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#333' : '#fff',
	borderBottomLeftRadius: '0.5rem',
	borderBottomRightRadius: '0.5rem',
	boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
	'& .formRow': {
		padding: '0.8rem',
	},
	'& .searchForm': {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: '1rem',
	},
	'& .formRow + .formRow': {
		paddingTop: 0,
	},
}))

// 애니메이션 정의
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

// 스타일링된 컴포넌트들
export const LoginContainer = styled(Container)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	minHeight: '100vh',
	background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a40 50%, #2d2d5f 100%)',
	position: 'relative',
	overflow: 'hidden',
	'&::before': {
		content: '""',
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		background: `
      radial-gradient(circle at 25% 25%, rgba(76, 81, 211, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 75% 75%, rgba(113, 132, 173, 0.1) 0%, transparent 50%)
    `,
		pointerEvents: 'none',
	},
}))

export const GridBackground = styled(Box)({
	position: 'absolute',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	opacity: 0.1,
	background: `
    linear-gradient(rgba(76, 81, 211, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(76, 81, 211, 0.1) 1px, transparent 1px)
  `,
	backgroundSize: '50px 50px',
	pointerEvents: 'none',
})

export const LoginPaper = styled(Paper)(({ theme }) => ({
	padding: theme.spacing(4),
	background: 'rgba(255, 255, 255, 0.05)',
	backdropFilter: 'blur(20px)',
	border: '1px solid rgba(255, 255, 255, 0.1)',
	borderRadius: '20px',
	boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
	width: '100%',
	maxWidth: '400px',
	animation: `${fadeInUp} 0.8s ease-out`,
	position: 'relative',
	zIndex: 1,
}))
